import React from 'react';
import { REACTION_ICON_PENDING } from '../../../../../common/constants/data-hooks';
import withLazy from '../../../../hoc/with-lazy';
const PlaceHolderIcon = () => (React.createElement("div", { "data-hook": REACTION_ICON_PENDING, style: {
        backgroundColor: 'transparent',
        borderRadius: '50%',
        width: `100%`,
        height: `100%`,
    } }));
export const AngryIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-angry-icon" */ './angry-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const ClapIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-clap-icon" */ './clap-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const CuriousIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-curious-icon" */ './curious-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const HahaIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-haha-icon" */ './haha-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const HeartIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-heart-icon" */ './heart-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const SadIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-sad-icon" */ './sad-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const WowIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-wow-icon" */ './wow-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const ThumbsUpIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-thumbs-up-icon" */ './thumbs-up-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
export const SmileyIconLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-smiley-icon" */ './smiley-icon'),
    loader: { type: 'COMPONENT', component: PlaceHolderIcon },
    errorHandling: { type: 'HANDLE' },
});
//# sourceMappingURL=index.js.map